module.exports = __webpack_public_path__ + "static/media/profFlooringIMG.5e2f0eae.jpg";